import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import AccountUserInvitePageUI from './AccountUserInvitePageUI.js'

class AccountUserInvitePageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
    }
  }

  render() {
    return (
      <AccountUserInvitePageUI
        context={this.props.context}
        messageList={this.state.messageList}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  getMessages(context) {
    let arr = [
      'c_invite_user',
      'c_invite',
      'c_phone',
      'c_email',
      'c_name',
      'c_first_name',
      'c_last_name',
      'c_account_role',
      'c_projects',
      'c_project_role',
      'c_message',
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_acc_usr_inv', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({messageList : response.messageList})
  }
}

export default AccountUserInvitePageSF
